import { VideoPlaylistTheme } from '@/components/VideoPlaylist/theme';
import { tw } from '@/utils/tw';

const VideoReels = tw.theme({
  extend: VideoPlaylistTheme,
});

export default VideoReels;
